(function () {
  function findForm() {
    return document.querySelector("form.ws-registration-form--form");
  }

  function injectHoneypot(form) {
    if (form.querySelector("input[name='ws_hp_field']")) return;

    const hp = document.createElement("input");
    hp.type = "text";
    hp.name = "ws_hp_field";
    hp.autocomplete = "off";
    hp.tabIndex = -1;
    hp.setAttribute("aria-hidden", "true");

    // Hide off-screen (do NOT use display:none)
    hp.style.position = "absolute";
    hp.style.left = "-9999px";
    hp.style.top = "-9999px";
    hp.style.height = "1px";
    hp.style.width = "1px";
    hp.style.opacity = "0";

    form.appendChild(hp);
  }

  function setErr(el, msg) {
    if (!el) return;
    el.setCustomValidity(msg || "");
    // show native message on blur/submit
  }

  function addInlineError(el) {
    if (!el) return;
    const wrap = el.closest(".ws--whole") || el.parentElement;
    if (!wrap) return;

    let box = wrap.querySelector(".js-field-error");
    if (!box) {
      box = document.createElement("div");
      box.className = "js-field-error";
      box.style.color = "#c00";
      box.style.fontSize = "12px";
      box.style.marginTop = "6px";
      wrap.appendChild(box);
    }
    box.textContent = el.validationMessage || "";
    box.style.display = el.validationMessage ? "block" : "none";

    el.style.borderColor = el.validationMessage ? "#c00" : "";
  }

  function init() {
    const form = findForm();
    if (!form) return false;

    injectHoneypot(form);

    // Fields (use name= customer[...] from your HTML)
    const firstName = form.querySelector("input[name='customer[first_name]']");
    const lastName = form.querySelector("input[name='customer[last_name]']");
    const phone = form.querySelector("input[name='customer[contact_number]']");
    const companyName = form.querySelector("input[name='address[company]']");
    const companyReg = form.querySelector("input[name='customer[company_reg_number]']");
    const vat = form.querySelector("input[name='customer[vat_number]'], input[id*='vat']");
    const soleTrader = form.querySelector("textarea[name*='sole'], textarea[id*='sole']");

    // Max lengths
    if (firstName) firstName.maxLength = 20;
    if (lastName) lastName.maxLength = 20;
    if (phone) phone.maxLength = 15;
    if (companyName) companyName.maxLength = 100;
    if (companyReg) companyReg.maxLength = 25;
    if (vat) vat.maxLength = 20;
    if (soleTrader) soleTrader.maxLength = 200;

    // Typing guards (safe)
    const onlyLetters = (v) => (v || "").replace(/[^a-zA-Z\s.'-]/g, "").replace(/\s{2,}/g, " ");
    const onlyDigits = (v) => (v || "").replace(/\D/g, "");

    if (firstName) {
      firstName.addEventListener("input", () => { firstName.value = onlyLetters(firstName.value).slice(0, 20); });
    }
    if (lastName) {
      lastName.addEventListener("input", () => { lastName.value = onlyLetters(lastName.value).slice(0, 20); });
    }
    if (phone) {
      phone.setAttribute("inputmode", "numeric");
      phone.addEventListener("input", () => { phone.value = onlyDigits(phone.value).slice(0, 15); });
    }

    function validate() {
      // Clear previous validity
      [firstName, lastName, phone, companyName, companyReg, vat, soleTrader].forEach(el => el && setErr(el, ""));

      // First/Last: required + no digits
      if (firstName) {
        const v = firstName.value.trim();
        if (!v) setErr(firstName, "First name is required.");
        else if (/[0-9]/.test(v)) setErr(firstName, "Numbers are not allowed.");
      }
      if (lastName) {
        const v = lastName.value.trim();
        if (!v) setErr(lastName, "Last name is required.");
        else if (/[0-9]/.test(v)) setErr(lastName, "Numbers are not allowed.");
      }

      // Phone: required + 10-15 digits
      if (phone) {
        const v = phone.value.trim();
        if (!v) setErr(phone, "Contact number is required.");
        else if (!/^[0-9]+$/.test(v)) setErr(phone, "Only numbers allowed.");
        else if (v.length < 10 || v.length > 15) setErr(phone, "Enter 10 to 15 digits.");
      }

      // Company rules (you set required in app, but we also validate)
      if (companyName) {
        const v = companyName.value.trim();
        if (!v) setErr(companyName, "Company name is required.");
      }
      if (companyReg) {
        const v = companyReg.value.trim();
        if (!v) setErr(companyReg, "Company reg number is required.");
      }

      // Sole trader conditional (optional)
      if (soleTrader) {
        const companyMissing =
          (companyName && !companyName.value.trim()) ||
          (companyReg && !companyReg.value.trim());

        if (companyMissing && !soleTrader.value.trim()) {
          setErr(soleTrader, "If you are a sole trader, please enter your full name.");
        }
      }

      // Update inline messages
      [firstName, lastName, phone, companyName, companyReg, vat, soleTrader].forEach(addInlineError);

      // Return overall validity
      return form.checkValidity();
    }

    // Fluid validation
    form.addEventListener("input", validate, true);
    form.addEventListener("blur", validate, true);

    // Submit protection without breaking app
    form.addEventListener("submit", function (e) {
      // Honeypot check (silent block)
      const hp = form.querySelector("input[name='ws_hp_field']");
      const appBot = form.querySelector("input[name='wsaio_bot_field']");

      if ((hp && hp.value.trim() !== "") || (appBot && appBot.value.trim() !== "")) {
        e.preventDefault();
        return;
      }

      if (!validate()) {
        e.preventDefault();
        form.reportValidity(); // native popup messages
        return;
      }
      // IMPORTANT: do not stopPropagation, let app submit handler run
    }, true);

    // initial run
    validate();
    return true;
  }

  // Retry because app loads late
  let tries = 0;
  const t = setInterval(() => {
    tries++;
    if (init() || tries > 40) clearInterval(t);
  }, 400);
})();
